import React from 'react';

const NavigationMenuNavTitle = ({ children, hidden = false, mouseOver, mouseLeave }) => (
  <div
    onFocus={() => {}}
    style={{ position: 'relative', display: hidden ? 'none' : 'block' }}
    onMouseOver={mouseOver}
    onMouseLeave={mouseLeave}
  >
    {children}
  </div>
);

export default NavigationMenuNavTitle;
